export const excludedClientDocuments = [
  '45.891.930/0001-10',
  '30.995.404/0001-23',
  '58.956.761/0001-00',
  '23.627.238/0001-47',
  '30.253.884/0001-57',
  '14.566.745/0001-27',
  '26.114.357/0001-94',
  '26.365.844/0001-20',
  '47.487.648/0001-06',
  '23.682.163/0001-05',
  '179.114.327-08',
  '38.162.474/0001-02',
  '28.167.216/0001-65',
  '47.825.514/0001-40',
  '45.413.446/0001-86',
  '10.751.728/0001-09',
  '22.963.481/0001-73',
  '26.966.497/0001-90',
  '335.092.598-74',
  '43.216.908/0001-40',
  '44.499.811/0001-54',
  '30.817.958/0001-30',
  '17.221.031/0001-75',
  '48.606.876/0001-02',
  '21.131.141/0001-13',
  '12.449.030/0001-69',
  '45.374.196/0001-12',
  '27.949.804/0001-98',
  '28.321.147/0001-00',
  '30.855.541/0001-62',
  '33.860.157/0001-46',
  '26.572.179/0001-45',
  '28.197.899/0001-01',
  '30.638.794/0001-84',
  '46.033.094/0001-04',
  '23.557.700/0001-87',
  '16.943.746/0001-79',
  '880.767.251-00',
  '28.529.452/0001-84',
  '21.514.766/0001-64',
  '28.311.286/0001-45',
  '16.596.845/0001-21',
  '14.206.078/0001-71',
  '32.760.547/0001-81',
  '25.230.322/0001-58',
  '09.261.539/0001-79',
  '50.328.082/0001-76',
  '02.256.723/0001-81',
  '27.777.394/0001-45',
  '20.854.483/0001-07',
  '029.409.419-98',
  '24.842.909/0001-55',
  '47.775.900/0001-74',
  '14.785.631/0001-78',
  '221.044.678-37',
  '32.250.936/0001-67',
  '27.422.604/0001-82',
  '27.570.065/0001-29',
  '27.757.321/0001-91',
  '32.511.031/0001-01',
  '39.269.855/0001-58',
  '23.756.169/0001-71',
  '32.810.224/0001-55',
  '40.334.359/0001-10',
  '44.007.829/0001-91',
  '31.534.152/0001-06',
  '95.443.818/0001-95',
  '14.833.920/0001-03',
  '90.964.198/0001-16',
  '49.793.904/0001-00',
  '09.198.360/0002-03',
  '43.968.113/0001-98',
  '37.374.964/0001-00',
  '48.029.261/0001-60',
  '83.198.549/0001-60',
  '22.320.749/0001-59',
  '46.465.454/0001-39',
  '27.217.455/0001-10',
  '48.105.443/0001-73',
  '17.740.855/0001-51',
  '11.077.977/0001-23',
  '30.441.590/0001-59',
  '15.104.875/0001-00',
  '39.953.512/0001-08',
  '91.634.626/0001-05',
  '34.357.274/0001-54',
  '35.551.162/0001-00',
  '39.660.571/0001-98',
  '00.324.544/0001-09',
  '34.155.096/0001-89',
  '18.819.968/0001-00',
  '51.851.277/0001-69',
  '22.080.989/0001-23',
  '31.378.224/0001-65',
  '04.403.829/0001-96',
  '22.593.721/0001-95',
  '29.971.013/0001-90',
  '42.071.760/0001-30',
  '816.114.207-68',
  '030.625.647-92',
  '38.040.318/0001-79',
  '26.890.905/0001-78',
  '14.222.461/0001-13',
  '10.492.639/0001-95',
  '37.887.674/0001-60',
  '21.784.391/0001-52',
  '50.283.504/0001-34',
  '28.661.218/0001-06',
  '305.375.410-04',
  '29.169.341/0001-77',
  '033.641.801-99',
  '40.217.408/0001-34',
  '21.865.263/0001-33',
  '26.142.334/0001-93',
  '31.595.914/0001-76',
  '22.471.420/0001-99',
  '54.927.579/0001-61',
  '47.259.950/0001-07',
  '21.202.796/0001-35',
  '03.097.579/0001-40',
  '12.309.334/0001-20',
  '10.303.797/0001-50',
  '51.511.798/0001-77',
  '18.164.719/0001-23',
  '03.724.759/0001-05',
  '05.324.303/0001-83',
  '43.734.302/0001-04',
  '46.221.527/0001-47',
  '31.180.746/0001-58',
  '43.753.018/0001-77',
  '08.261.203/0001-43',
  '22.172.268/0001-43',
  '27.616.110/0001-39',
  '08.490.515/0001-29',
  '27.173.565/0001-27',
  '40.371.035/0001-51',
  '27.307.713/0001-59',
  '51.751.304/0001-21',
  '57.591.044/0001-50',
  '26.231.219/0001-95',
  '74.141.995/0001-47',
  '89.876.338/0001-15',
  '67.053.462/0001-48',
  '05.360.595/0001-00',
  '09.535.810/0001-17',
  '12.284.157/0001-75',
  '09.564.409/0001-05',
  '39.503.385/0001-45',
  '38.421.180/0001-58',
  '35.384.691/0001-59',
  '09.612.510/0001-94',
  '23.000.542/0001-60',
  '23.812.329/0001-52',
  '24.492.442/0001-60',
  '48.939.073/0001-70',
  '32.392.757/0001-64',
  '25.206.711/0001-48',
  '37.521.512/0001-03',
  '51.291.976/0001-00',
  '23.509.579/0001-18',
  '978.067.739-91',
  '08.895.106/0001-02',
  '45.053.389/0001-71',
  '44.461.045/0001-39',
  '44.839.437/0001-99',
  '395.993.026-72',
  '52.852.186/0001-00',
  '149.888.508-03',
  '09.096.731/0001-57',
  '29.896.038/0001-76',
  '04.059.107/0001-66',
  '42.984.230/0001-82',
];
